// extracted by mini-css-extract-plugin
module.exports = {"label":"AttributeAssigner_label__3QQFC","container":"AttributeAssigner_container__MJlK8"};